export const QUESTION_DATA_TYPES = Object.freeze({
  BOOLEAN: 'boolean',
  NUMBER: 'number',
  TEXT: 'text',
  MULTIPLE_CHOICE: 'multiple_choice',
  DROPDOWN: 'dropdown',
});

export const ALL_QUESTION_DATA_TYPES = Object.freeze([
  QUESTION_DATA_TYPES.BOOLEAN,
  QUESTION_DATA_TYPES.NUMBER,
  QUESTION_DATA_TYPES.TEXT,
  QUESTION_DATA_TYPES.MULTIPLE_CHOICE,
  QUESTION_DATA_TYPES.DROPDOWN,
]);

export function isChoiceBasedType(dataType) {
  return (
    dataType === QUESTION_DATA_TYPES.MULTIPLE_CHOICE ||
    dataType === QUESTION_DATA_TYPES.DROPDOWN
  );
}

export function isMultipleChoice(dataType) {
  return dataType === QUESTION_DATA_TYPES.MULTIPLE_CHOICE;
}

export function hasChoices(choices) {
  return Array.isArray(choices) && choices.length > 0;
}

export function canSubmitQuestion({ name, dataType, choices }) {
  const hasName = Boolean(name && String(name).trim().length > 0);
  const hasType = Boolean(dataType);
  return (
    hasName &&
    hasType &&
    (isChoiceBasedType(dataType) ? hasChoices(choices) : true)
  );
}

export const parseQuestions = (questions) => {
  const parsed = questions.map((question) => {
    if (isChoiceBasedType(question.data_type)) {
      return {
        ...question,
        choices: question.choices.map((choice) => ({ body: choice })),
      };
    }
    return question;
  });
  return parsed;
};
